module.exports = __webpack_public_path__ + "img/prospect_anaccesscompany_blue.9e028709.svg";